import { API_TYPE, fetchData, IResponse } from '@umu/umu-fetch';
import { handlePromiseError } from 'common/utils/errorHandler';

const PHP_BASE = '/uapi/v1';
// 支付状态接口
export interface IPaymentStatusData {
    pay_status: 'success' | 'fail' | 'pay' | string;
}

const API = {
    CHECK_PAYMENT_STATUS: {
        url: `${PHP_BASE}/enroll/pay-status`,
        type: API_TYPE.GET,
    },
};

/**
 * 查询订单支付状态
 * @param orderNo 订单号
 * @returns 支付状态信息
 */
export const checkPaymentStatus = async (orderNo: string): Promise<IPaymentStatusData> => {
    return fetchData(API.CHECK_PAYMENT_STATUS, { order_no: orderNo })
        .then((res: IResponse<IPaymentStatusData>) => {
            return res.data;
        })
        .catch((error: unknown) => {
            handlePromiseError(error, 'checkPaymentStatus', 'checkPaymentStatus fetchData error', { orderNo });
        });
};
